// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/star-filled.svg';

export const StarFilled = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
